/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoginPayload } from '../../models/loginPayload';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { ForgotPayload } from '../../models/forgotPayload';
import { ForgotResponse } from '../../models/forgotResponse';
import { VerifyOtpPayload } from '../../models/verifyOtpPayload';
import { ResetPasswordPayload } from '../../models/resetPasswordPayload';
import { ResetPasswordResponse } from '../../models/resetPasswordResponse';
import { ProfilePayload } from '../../models/profilePayload';
import { ChangePasswordPayload } from '../../models/changePasswordPayload';
import { LoginResponse } from 'src/app/models/loginResponse';
import Swal from 'sweetalert2';
import { logoutResponse } from 'src/app/models/logoutResponse';
import { messageResponse } from '../../models/messageResponse';
import { CommonResponse } from 'src/app/models/commomResponse';
import { VerifyOtpResponse } from 'src/app/models/verifyOtpResponse';
import { validatePayload } from 'src/app/models/validatePayload';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  FCMtoken: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(
    null
  );
  emailSubject: BehaviorSubject<ForgotPayload | null> =
    new BehaviorSubject<ForgotPayload | null>(null);

  profileDetails: BehaviorSubject<LoginResponse | null> =
    new BehaviorSubject<LoginResponse | null>(null);

  resetTokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');

  private isOpenSubject = new BehaviorSubject<boolean>(false);

  socketTest: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  isOpen$ = this.isOpenSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private _translateService: TranslateService
  ) {}

  isAuthenticated(): boolean {
    if (
      localStorage.getItem(environment.storageKey) &&
      localStorage.getItem(environment.storageKey) !== null
    ) {
      return true;
    } else {
      return false;
    }
  }

  loginUser(loginDetails: LoginPayload): Observable<LoginResponse> {
    return this.http
      .post<{
        data: LoginResponse;
      }>(`${environment.base_url}login`, loginDetails)
      .pipe(map(res => res.data));
  }

  forgotPassword(email: ForgotPayload): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}forgotPassword`,
      email
    );
  }

  verifyOtp(otp: VerifyOtpPayload): Observable<VerifyOtpResponse> {
    return this.http
      .post<{
        data: VerifyOtpResponse;
      }>(`${environment.base_url}verifyOtp`, otp)
      .pipe(map(res => res.data));
  }

  verifyValidatedOtp(otp: validatePayload): Observable<LoginResponse> {
    return this.http
      .post<{
        data: LoginResponse;
      }>(`${environment.base_url}verifyValidate`, otp)
      .pipe(map(res => res.data));
  }

  resetPassword(data: ResetPasswordPayload): Observable<ResetPasswordResponse> {
    return this.http
      .post<ResetPasswordResponse>(`${environment.base_url}resetPassword`, data)
      .pipe(map(res => res));
  }

  resendOtp(email: ForgotPayload): Observable<ForgotResponse> {
    return this.http
      .post<ForgotResponse>(`${environment.base_url}sendOtp`, email)
      .pipe(map(res => res));
  }

  getProfile(): Observable<LoginResponse> {
    return this.http
      .get<{ data: LoginResponse }>(`${environment.base_url}getProfile`)
      .pipe(map(res => res.data));
  }

  updateProfile(data: ProfilePayload): Observable<LoginResponse> {
    return this.http
      .put<{
        data: LoginResponse;
      }>(`${environment.base_url}updateProfile`, data)
      .pipe(map(res => res.data));
  }

  changePassword(data: ChangePasswordPayload): Observable<messageResponse> {
    return this.http
      .post<messageResponse>(`${environment.base_url}changePassword`, data)
      .pipe(map(res => res));
  }

  logout(): Observable<logoutResponse> {
    return this.http.get<logoutResponse>(`${environment.base_url}logout`);
  }
  toggle(): void {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  logoutAlert(): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this._translateService.instant('AreYouSure'),
        text: this._translateService.instant('Youwillbeloggedout'),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this._translateService.instant('Cancel'),
        confirmButtonColor: '#f3e00b',
        cancelButtonColor: '#000',
        confirmButtonText: this._translateService.instant('Logout')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }

  passwordChangedLogout(): Promise<any> {
    return new Promise((resolve: any) => {
      Swal.fire({
        title: this._translateService.instant('PasswordUpdatedSuccessfully'),
        text: this._translateService.instant('Youwillbeloggedout'),
        icon: 'success'
      }).then((result: any) => {
        return resolve(result);
      });
    });
  }
  private drawerOpen = false;

  getDrawerOpen(): boolean {
    return this.drawerOpen;
  }
  toggleDrawer(): void {
    this.drawerOpen = !this.drawerOpen;
  }
}
